export enum ModalView {
  Main = 'main',
  Playbook = 'playbook',
  KeyFindings = 'keyFindings',
  KeyFindingsDetail = 'keyFindingsDetail',
}
